/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-no-bind */

'use client'

import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import { useUserContext } from '@context/UserContext/UserContenxt'
import { useModalContext } from '@context/ModalContext/ModalContext'
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button'
import { ThemeProvider } from 'styled-components'
import { AckoMainTheme } from '@acko-tech/building-blocks.ui.theme'
import StyledComponentsRegistry from '@configs/registry'
import { r2d2 } from '@utils/utils'
import { useUserData } from '@utils/userUserData'
import { pageEvent, trackEvent, waitForAnalyticsLoad } from '@acko-tech/building-blocks.ui.acko-analytics'
import { autoService } from '@services/autoService'
import assetLoader from '@utils/internalImageLoader'
import Cookies from 'js-cookie'
import { WebViewActions, callWebviewHandlerV2 } from '@utils/webview'
import { deepLinkConfig } from '@configs/deeplink.config'
import { WidgetType } from '@enums/WidgetType'
import styles from './fastagWidget.module.scss'
import FastagModal from './FastagModal'
import { FastagWidgetProps } from './fastagWidgetInterface'
import { validateRegNo } from './helper'
import {
  BIKE_NUMBER_ERROR,
  CHECK_FASTAG_FALLBACK,
  ENTER_CAR_NUMBER,
  FASTAG_WIDGET_HEADING,
  INPUT_ICON,
  INPUT_ICON_LOGO,
  INPUT_PLACEHOLDER,
  PHONE_NUMBER_ENTERED,
  PRODUCT_NAME,
  R2D2_LINK,
  REGISTRATION_NUMBER_ERROR,
  TAP_BTN_EVENT,
  TWO_WHEELER,
  UNABLE_TO_FETCH,
  VIEW_PAGE_EVENT,
} from './constants'

interface AutoData {
  vehicleType?: string
}

const fastagWidget = ({
  widgetHeading,
  widgetCtaText,
  segmentEventCommonProperties,
  KeyFeatures: keyFeatures,
  regexPatternsData,
}: FastagWidgetProps) => {
  const [regNo, setRegNo] = useState('')
  const [errors, setErrors] = useState('')
  const [isFetching, setIsFetching] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [autoData, setAutoData] = useState<AutoData>({})
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [showLoginModal, setShowLoginModal] = useState(false)
  const [phone, setPhone] = useState('')
  const { show, setShow } = useModalContext()
  const { isLoggedIn, setUserLoggedIn } = useUserContext()
  const [phoneNumberFired, setPhoneNumberFired] = useState(false)
  const userData = useUserData(isLoggedIn)
  const [showFastagDetails, setShowFastagDetails] = useState(false)
  const [fastagData, setFastagData] = useState<any>([])

  useEffect(() => {
    showModal
      ? (document.documentElement.style.overflowY = 'hidden')
      : (document.documentElement.style.overflowY = 'scroll')
  }, [showModal])

  useEffect(() => {
    pageEvent(VIEW_PAGE_EVENT, {
      ...segmentEventCommonProperties,
      product: PRODUCT_NAME,
    })
  }, [])

  useEffect(() => {
    if (Cookies.get('webview')) {
      callWebviewHandlerV2({ url: deepLinkConfig[WidgetType.FASTAG], action: WebViewActions.OPEN_DEEPLINK })
    }
  }, [])

  useEffect(() => {
    setPhone(userData?.phone || '-')
  }, [userData])

  useEffect(() => {
    if (isLoggedIn && showFastagDetails && fastagData) {
      waitForAnalyticsLoad().then(() => {
        pageEvent(VIEW_PAGE_EVENT, {
          ...segmentEventCommonProperties,
          product: PRODUCT_NAME,
          phone: phone || userData?.phone,
          registration_number: regNo,
          vehicle_type: 'CAR',
          vas_amount: fastagData?.balance || '-',
        })
      })
    }
  }, [showFastagDetails, isLoggedIn, fastagData])

  const verifyOtpSuccess = async () => {
    trackEvent('otp_entered', {
      ...segmentEventCommonProperties,
      product: 'product',
      phone: phone || '-',
      registration_number: regNo,
    })
    setUserLoggedIn(true)
    setIsModalOpen(false)
    setShowLoginModal(false)
    setShowFastagDetails(true)
  }

  useEffect(() => {
    if (phone && isModalOpen && !phoneNumberFired) {
      trackEvent(PHONE_NUMBER_ENTERED, {
        ...segmentEventCommonProperties,
        product: PRODUCT_NAME,
        phone: phone || userData?.phone,
        registration_number: regNo,
      })
      setPhoneNumberFired(true)
    }
  }, [phone])

  function callR2d2(data) {
    const phoneNumber = data?.edata?.phone
    if (data?.ekind === 'otp_verified') {
      trackEvent('otp_entered', {
        ...segmentEventCommonProperties,
        product: 'product',
        phone: phoneNumber || '-',
        registration_number: regNo,
      })
    }
    setPhone(data?.edata?.phone || userData?.phone)
    return r2d2({}, R2D2_LINK)
  }

  const fetchfastadallprovider = async () => {
    trackEvent(TAP_BTN_EVENT, {
      ...segmentEventCommonProperties,
      product: PRODUCT_NAME,
      phone: phone || '-',
      registration_number: regNo,
    })

    try {
      setIsFetching(true)
      const data = await autoService(regNo)
      setAutoData(data)
      if (data.vehicle_type_v2 === TWO_WHEELER) {
        setShowModal(false)
        setIsFetching(false)
        setErrors(BIKE_NUMBER_ERROR)
        return null
      } else {
        setShowModal(true)
        setIsFetching(false)
        setErrors('')
        setShowFastagDetails(false)
      }
    } catch (err) {
      setIsFetching(false)
      setErrors(UNABLE_TO_FETCH)
      console.error(err, 'error on fastag container')
    }
  }
  const getChallan = async () => {
    // Use the helper function to validate the registration number
    if (!regNo) {
      setErrors(ENTER_CAR_NUMBER)
      return null
    } else if (!validateRegNo(regNo, regexPatternsData)) {
      setErrors(REGISTRATION_NUMBER_ERROR)
      return null
    }
    fetchfastadallprovider()
  }

  const onSubmit = e => {
    e.preventDefault()
    getChallan()
  }

  return (
    <ThemeProvider theme={AckoMainTheme}>
      <div className={`${styles.mainContainer} ${show ? styles.mainContainerModalOpen : ''}`}>
        <form
          action=""
          className={`${styles.widgetForm} ${show ? styles.widgetFormModal : ''}`}
          onSubmit={e => onSubmit(e)}>
          <label htmlFor="fastagInput" className={styles.widgetHeading}>
            {widgetHeading ? widgetHeading : FASTAG_WIDGET_HEADING}
          </label>
          <div className={styles.InputBoxContainer}>
            <Image
              width={0}
              height={0}
              src={`${assetLoader()}${INPUT_ICON}`}
              className={styles.inputIcon}
              alt={INPUT_ICON_LOGO}
            />
            <input
              type="text"
              id="fastagInput"
              placeholder={INPUT_PLACEHOLDER}
              onChange={e => setRegNo(e.target.value.toUpperCase())}
              autoComplete="off"
            />
          </div>
          {errors && <div className={styles.inputError}>{errors}</div>}
          <StyledComponentsRegistry>
            <PrimaryButton loading={isFetching} className={styles.primaryButton}>
              {widgetCtaText ? widgetCtaText : CHECK_FASTAG_FALLBACK}
            </PrimaryButton>
          </StyledComponentsRegistry>
        </form>
        {showModal && (
          <FastagModal
            setShow={setShow}
            keyFeatures={keyFeatures}
            segmentEventCommonProperties={segmentEventCommonProperties}
            autoData={autoData}
            regNo={regNo}
            setShowModal={setShowModal}
            showLoginModal={showLoginModal}
            setIsModalOpen={setIsModalOpen}
            isModalOpen={isModalOpen}
            verifyOtpSuccess={verifyOtpSuccess}
            callR2d2={callR2d2}
            setShowLoginModal={setShowLoginModal}
            isLoggedIn={isLoggedIn}
            showFastagDetails={showFastagDetails}
            setShowFastagDetails={setShowFastagDetails}
            phone={phone}
            fastagData={fastagData}
            setFastagData={setFastagData}
          />
        )}
      </div>
    </ThemeProvider>
  )
}

export default fastagWidget
